module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"no.item":"Aucune entrée définie"}}')
  delete Component.options._Ctor
}
